module.exports = __webpack_public_path__ + "static/media/Jeff Bezos.d4fe0c1f.jpg";